import { USER_TOKEN_LOCAL_STORAGE_KEY } from "../axios/constants";
import { clear, get, set } from "./local-storage";

export const setOnLocalStorage = (clinic) => set(USER_TOKEN_LOCAL_STORAGE_KEY, clinic);
export const getFromLocalStorage = () => get(USER_TOKEN_LOCAL_STORAGE_KEY);
export const clearOnLocalStorage = () => clear(USER_TOKEN_LOCAL_STORAGE_KEY);